// extracted by mini-css-extract-plugin
export default {"displayGrid":"styles_displayGrid__RK6DH","badges":"styles_badges__Bvogs","avatar":"styles_avatar__r5u0n","image":"styles_image__++dcr","badge":"styles_badge__50FkA"};